import React from 'react';
import { ImageFile } from '~/data/types/images';

const shareCopyLinkIconIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#00D6D1" />
      <g clipPath="url(#clip0_971_101226)">
        <path
          d="M12.4678 15.0061L10.5977 16.8762C10.5977 16.8762 10.5977 16.8762 10.5977 16.8762C10.5977 16.8762 10.5977 16.8762 10.5976 16.8762C9.82428 17.6496 8.56591 17.6497 7.7925 16.8762C7.41783 16.5016 7.21153 16.0034 7.21153 15.4736C7.21153 14.9439 7.41782 14.4459 7.79237 14.0712C7.79241 14.0711 7.79245 14.0711 7.7925 14.071L9.66256 12.2009C9.92073 11.9427 9.92073 11.5241 9.66251 11.2659C9.40434 11.0077 8.98568 11.0077 8.72746 11.2659L6.8574 13.136C6.85727 13.1361 6.85714 13.1363 6.85701 13.1364C6.23289 13.7608 5.88916 14.5908 5.88916 15.4736C5.88916 16.3567 6.23302 17.1869 6.85745 17.8113C7.50197 18.4558 8.34851 18.778 9.1951 18.778C10.0417 18.778 10.8883 18.4558 11.5327 17.8113V17.8113C11.5327 17.8113 11.5327 17.8112 11.5327 17.8112L13.4028 15.9411C13.661 15.6829 13.661 15.2643 13.4028 15.0061C13.1446 14.7479 12.726 14.7479 12.4678 15.0061Z"
          fill="black"
        />
        <path
          d="M18.1112 9.86295C18.1112 8.97991 17.7673 8.14972 17.1429 7.5253C15.8539 6.23634 13.7566 6.23638 12.4677 7.5253C12.4676 7.52539 12.4675 7.52543 12.4675 7.52552L10.5975 9.39549C10.3393 9.65366 10.3393 10.0724 10.5975 10.3305C10.7266 10.4597 10.8958 10.5242 11.065 10.5242C11.2342 10.5242 11.4035 10.4596 11.5325 10.3305L13.4025 8.46057C13.4026 8.46048 13.4027 8.46044 13.4028 8.46035C14.1761 7.68703 15.4345 7.68698 16.2079 8.46035C16.5825 8.83502 16.7889 9.33316 16.7889 9.86295C16.7889 10.3927 16.5826 10.8907 16.208 11.2654C16.208 11.2655 16.2079 11.2655 16.2079 11.2655L14.3378 13.1356C14.0796 13.3938 14.0796 13.8125 14.3378 14.0707C14.467 14.1998 14.6362 14.2644 14.8054 14.2644C14.9746 14.2644 15.1438 14.1998 15.2729 14.0707L17.143 12.2006C17.1431 12.2005 17.1432 12.2003 17.1434 12.2002C17.7675 11.5758 18.1112 10.7458 18.1112 9.86295Z"
          fill="black"
        />
        <path
          d="M9.66241 15.0056C9.79152 15.1347 9.96074 15.1993 10.1299 15.1993C10.2991 15.1993 10.4684 15.1347 10.5975 15.0056L14.3377 11.2654C14.5959 11.0072 14.5959 10.5886 14.3377 10.3303C14.0795 10.0722 13.6608 10.0722 13.4026 10.3303L9.66241 14.0705C9.4042 14.3288 9.4042 14.7474 9.66241 15.0056Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_971_101226">
          <rect
            width="12.2222"
            height="12.2222"
            fill="white"
            transform="translate(5.88916 6.55664)"
          />
        </clipPath>
      </defs>
    </Component>
  );
};

export default shareCopyLinkIconIcon;
